"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _breakpoints = _interopRequireDefault(require("./breakpoints"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @deprecated use `@zip/theme` instead - https://gitlab.com/zip-au/customer-engagement/theme
 */
var theme = {
  breakpoints: _breakpoints["default"],
  colors: {
    get primary() {
      return this.navy;
    },

    get accent() {
      return this.blue;
    },

    error: '#B00020',
    neutral50: '#F9F9FB',
    neutral100: '#F2F2F2',
    neutral200: '#E8E8EC',
    neutral300: '#DDDDE3',
    neutral400: '#A5ABC1',
    neutral500: '#6E7396',
    neutral600: '#424876',
    black: '#000000',
    blue: '#1C70F2',
    navy: '#21285E',
    red: '#F15C3E',
    teal: '#00AEB8',
    white: '#FFFFFF',
    yellow: '#F8991C'
  },
  layout: {
    maxWidthDesktop: '375px'
  },
  typography: {
    fontFamily: '"Sharp Grotesk", sans-serif',
    fontSize: '15px',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    lineHeight: '1.467em'
  }
};
var _default = theme;
exports["default"] = _default;